<div class="d-flex justify-content-between">
  <h4 class="font-weight-bold">Low Performing Suppliers List</h4>
  <button class="btn button btn-primary m-2 btn-width" (click)="download()"> Download </button>
</div>
<hr class="my-2">
<mat-tab-group>
  <mat-tab class="font-weight-bold" *ngFor="let item of dataSource" label="{{ LowPerformers[item.name] }}">
    <div class="table">
      <table mat-table [dataSource]="item.performers" matSort class="w-100">
  
        <!-- number column -->
        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="bold-header px-2"> # </th>
          <td mat-cell *matCellDef="let row ;let i = index" class="title-column p-2"> {{ i + 1 }} </td>
        </ng-container>
  
        <!-- Parent column -->
        <ng-container matColumnDef="parent">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-2"> Parent </th>
          <td mat-cell *matCellDef="let row" class="p-2"> {{row.parent}} </td>
        </ng-container>
  
        <!-- Commodity column -->
        <ng-container matColumnDef="commodity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-2"> Commodity </th>
          <td mat-cell *matCellDef="let row" class="p-2"> {{row?.commodity}} </td>
        </ng-container>
  
        <!-- Score column -->
        <ng-container matColumnDef="score">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-2"> {{ item.name === 'worstOverAllScore' ? 'Overall Score' : 'Performance Score'}} </th>
          <td mat-cell *matCellDef="let row" class="p-2"> {{row?.score}} </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </mat-tab>
</mat-tab-group>